export default __webpack_public_path__ + "static/media/yeti_yeti_4.1be4a2a2.png";